import React, { useState, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";
import Select from "react-select";
import { Platform } from "react-native";
import { Typography } from "components/ui/Typography";
import { RefreshCcw } from "lucide-react-native";

const SignatureTabs = ({ handleCanvasChange, sigCanvasRef, clearSignature, isDrawingMode, setIsDrawingMode, typedSignature, setTypedSignature, selectedFont, setSelectedFont }: any) => {
	if (Platform.OS !== "web") {
		return null;
	}

	const [activeTab, setActiveTab] = useState("draw");
	const [fontsLoaded, setFontsLoaded] = useState(false);
	
	// Load Google Fonts dynamically when component mounts
	useEffect(() => {
		const loadGoogleFonts = () => {
			// Check if fonts are already loaded
			if (document.querySelector('#signature-fonts')) {
				setFontsLoaded(true);
				return;
			}

			// Create link element for Google Fonts
			const link = document.createElement('link');
			link.id = 'signature-fonts';
			link.rel = 'stylesheet';
			link.href = 'https://fonts.googleapis.com/css2?family=Pacifico&family=Great+Vibes&family=Dancing+Script:wght@400;700&family=Caveat:wght@400;700&family=Allura&family=Sacramento&family=Tangerine:wght@400;700&family=Indie+Flower&family=Lobster&family=Cookie&display=swap';
			
			// Add onload event to know when fonts are ready
			link.onload = () => {
				setFontsLoaded(true);
			};
			
			// Add to document head
			document.head.appendChild(link);
		};

		loadGoogleFonts();

		// Cleanup function to remove fonts when component unmounts
		return () => {
			const linkElement = document.querySelector('#signature-fonts');
			if (linkElement) {
				document.head.removeChild(linkElement);
			}
		};
	}, []);

	// Show loading state while fonts are loading
	if (!fontsLoaded) {
		return (
			<div className="signature-container">
				<Typography>Loading signature fonts...</Typography>
			</div>
		);
	}

	const fonts = [
		{ value: "Pacifico", label: "Pacifico" },
		{ value: "Great Vibes", label: "Great Vibes" },
		{ value: "Dancing Script", label: "Dancing Script" },
		{ value: "Caveat", label: "Caveat" },
		{ value: "Sacramento", label: "Sacramento" },
		{ value: "Tangerine", label: "Tangerine" },
		{ value: "Indie Flower", label: "Indie Flower" },
		{ value: "Lobster", label: "Lobster" },
		{ value: "Cookie", label: "Cookie" },
		{ value: "Allura", label: "Allura" },
	];
	const handleTabClick = (tab: any) => {
		if (tab === "type") {
			setIsDrawingMode(false);
		} else {
			setIsDrawingMode(true);
		}
		clearSignature();
		setActiveTab(tab);
	};

	const handleFontChange = (selectedOption: any) => {
		setSelectedFont(selectedOption);
	};
	const customStyles = {
		container: (provided: any) => ({
			...provided,
			maxWidth: "150px",
		}),
		option: (provided: any, state: any) => ({
			...provided,
			fontFamily: state.data.value,
			fontSize: "16px",
		}),
	};

	return (
		<div className="signature-container">
			<ul className="signature-tabs">
				<li className={activeTab === "draw" ? "active" : ""} onClick={() => handleTabClick("draw")}>
					<Typography>Draw Signature</Typography>
				</li>
				<li className={activeTab === "type" ? "active" : ""} onClick={() => handleTabClick("type")}>
					<Typography>Type Signature</Typography>
				</li>
				<div className="clear" onClick={clearSignature} title="Clear the signature">
					<RefreshCcw />
					{/* <AiOutlineReload /> */}
				</div>
			</ul>
			<div className="signature-content">
				{activeTab === "draw" && (
					<div className="signature-canvas">
						<SignatureCanvas
							ref={sigCanvasRef}
							minWidth={1}
							maxWidth={3}
							onEnd={handleCanvasChange}
							canvasProps={{
								width: 500,
								height: 200,
								className: "sigCanvas",
							}}
						/>
						<Typography.ParagraphSmall sx={{ color: "#898989", marginTop: 12 }}>
							By signing this document with electronic signature, I agree that such signature will be valid as handwritten signatures to the extent allowed by local law.{" "}
						</Typography.ParagraphSmall>
					</div>
				)}
				{activeTab === "type" && (
					<>
						<Select
							value={selectedFont}
							onChange={handleFontChange}
							options={fonts}
							className="font-select"
							styles={customStyles}
							isSearchable={false}
							components={{
								IndicatorSeparator: () => null,
							}}
						/>
						<div className="signature-type">
							<input type="text" value={typedSignature} onChange={(e) => setTypedSignature(e.target.value)} style={{ fontFamily: selectedFont.value }} />
							<p className="consent">By signing this document with electronic signature, I agree that such signature will be valid as handwritten signatures to the extent allowed by local law. </p>
						</div>
					</>
				)}
			</div>
		</div>
	);
};

export default SignatureTabs;
